import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import type {
  IResponseContactUnlinkedSource,
  IResponseContactUnlinkedConflictItem,
} from 'entities/Contacts/api/types'
import type { IntegrationKey } from 'entities/Integrations'
import { ReconnectButton } from 'widgets/ContactsDetails/ui/ContactsIntegrations/ui/ReconnectButton/ReconnectButton'
import {
  ProviderLinkContact,
  useLinkContactContext,
} from 'pages/contacts/pages/cleanup/ui/ContactsUnlinkedTable/ui/LinkContact/context/linkContactContext'
import { type LinkContactStore } from '../store/linkContactStore'
import styles from './styles.module.scss'

type ILinkContactContentProps = {
  contact: IResponseContactUnlinkedSource
  matchedContacts: IResponseContactUnlinkedConflictItem[]
  integration: IntegrationKey | null
}

const LinkContactContent: FC<ILinkContactContentProps> = observer(
  ({ contact, matchedContacts, integration }) => {
    const { init, openLinkContactModal, getIntegration } = useLinkContactContext()
    const isIntegrationConnected = getIntegration(integration)?.isConnected
    const showLinkButton = !integration || isIntegrationConnected

    const handleLink = () => {
      init(contact, matchedContacts, integration)
      openLinkContactModal()
    }

    return showLinkButton ? (
      <Button
        size={'medium'}
        contained={'tertiary'}
        text={'Link'}
        onClick={handleLink}
        className={styles.linkButton}
      />
    ) : (
      <ReconnectButton
        redirectKey={integration}
        buttonProps={{
          contained: 'secondary',
          fullWidth: false,
          className: styles.linkButton,
        }}
      />
    )
  }
)

type ILinkContactProps = {
  store: LinkContactStore
  contact: IResponseContactUnlinkedSource
  matchedContacts: IResponseContactUnlinkedConflictItem[]
  integration: IntegrationKey | null
}

export const LinkContact: FC<ILinkContactProps> = observer(
  ({ contact, matchedContacts, integration, store }) => {
    return (
      <ProviderLinkContact value={store}>
        <LinkContactContent
          contact={contact}
          matchedContacts={matchedContacts}
          integration={integration}
        />
      </ProviderLinkContact>
    )
  }
)
